<template>
    <v-container fluid fill-height>
        <v-layout flex align-center justify-center>
            <div class="wrapper-login">
                <h1 class="headline">Login</h1>
                <v-list v-if="errorShow && !loading" style="background: rgba(0, 0, 0, 0)">
                    <div class="error--text body-2">Wrong E-mail or Password</div>
                </v-list>
                <v-form @submit.prevent="">
                    <v-text-field
                        id="email"
                        name="email"
                        type="email"
                        label="E-mail*"
                        v-model.trim="authenticate.email"
                        required
                        autofocus
                        placeholder="Please Enter"
                        :error-messages="errors($v.authenticate.email)"
                        @blur="$v.authenticate.email.$touch()"
                        @keydown.enter="login"
                    >
                    </v-text-field>
                    <v-text-field
                        id="password"
                        name="password"
                        label="Password*"
                        v-model.trim="authenticate.password"
                        :append-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="e1 = !e1"
                        :type="e1 ? 'password' : 'text'"
                        placeholder="Please Enter"
                        required
                        :error-messages="errors($v.authenticate.password)"
                        @blur="$v.authenticate.password.$touch()"
                        @keydown.enter="login">
                    </v-text-field>
                    <v-alert class="pa-2 mt-3" :value="$v.authenticate.$error" outlined color="error" icon="mdi-alert" transition="scale-transition">
                        <span class="caption">Please fill out all fields correctly</span>
                    </v-alert>
                    <v-btn
                        id="btnLogin"
                        block
                        color="primary"
                        :loading="loading"
                        :disabled="loading"
                        @click="login">
                        Login
                    </v-btn>
                   <span id="forgot-password-link" class="text-center">
                       <router-link to="reset_password">Forgot Your Password?</router-link>
                   </span>
                </v-form>
            </div>
        </v-layout>
    </v-container>
</template>

<script>
    import { validationMixin } from 'vuelidate'
    import { required, email } from 'vuelidate/lib/validators'
    import { valMessages, getValMessage } from '@/common/error-messages'
    import {mapState, mapGetters} from "vuex"
    import {LOGIN} from "@/store/actions.type"

    const validations = {
        authenticate: {
            email: { required, email },
            password: { required }
        }
    }
    export default {
        name: 'Login',
        mixins: [validationMixin],
        validations,
        data: () => ({
            errorShow: false,
            authenticate: {
                email: '',
                password: '',
                timezone:''
            },
            loading: false,
            e1: true,
        }),
        methods: {
            login() {
                this.errorShow = false
                this.$v.authenticate.$touch()
                if(!this.$v.authenticate.$invalid) {
                    this.loading = true
                    this.$store
                        .dispatch(LOGIN, this.authenticate)
                        .then(response => {
                            this.$router.push({name: "dashboard"})
                            this.loading = false
                        })
                        .catch(({ response }) => {
                            this.loading = false
                            this.errorShow = true
                        })
                }
            },
            // Title case
            titleCase(str){
                return _.startCase(str.replace(/_/g, ' '))
            },
            errors: getValMessage(valMessages)(validations)
        },
        computed: {
            ...mapState({
                server_errors: state => state.auth.errors
            })
        }
    }
</script>

<style>
    .wrapper-login h1 {
        text-align: center;
        padding-bottom: 20px;
    }

    .wrapper-login {
        width: 100%;
        max-width: 300px;
    }

    .wrapper-login #forgot-password-link, .wrapper-login {
        display: block;
        margin-top: 15px;
    }

    .btn__content {
        padding-top: 2px;
        height: fit-content;
    }
</style>
